// extracted by mini-css-extract-plugin
module.exports = {"noti":"Noti_noti__18hb1"};